import styled, { keyframes } from 'styled-components';
import { Form } from '@unform/web';
import { TabPanel } from '@chakra-ui/react';

const appearFromLeft = keyframes`
  from {
    opacity: 0;
    transform: translateX(500px);
  }
  to {
    opacity: 1;
    transform: translateX(0px);
  }
`;

const appearFromTop = keyframes`
  from {
    opacity: 0;
    transform: translateY(500px);
  }
  to {
    opacity: 1;
    transform: translateY(0px);
  }
`;

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
  position: fixed;
	top: 0;
  z-index: 10;

  .active {
    opacity: 1;
    visibility: visible;
    right: 0px;
    animation: ${appearFromLeft} 0.5s;

    @media (max-width: 650px) {
      top: 0px;
      animation: ${appearFromTop} 0.5s;
    }
  }

  div::-webkit-scrollbar {
    display: none; /* Might be enough */
    background: transparent;
    visibility: hidden;
    width: 0px;
  }
  div {
    -ms-overflow-style: none;
    overflow: -moz-scrollbars-none;
    scrollbar-width: none;
  }
`;

export const Content = styled.div`
  background: #fff;
  position: fixed;
  right: -450px;
  width: 700px;
  height: 100%;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.3);
  visibility: hidden;
  opacity: 0;
  border-radius: 3px;
  padding: 0 20px 1.875rem;
  transition: all 0.5s ease-out;

  @media (max-width: 850px) {
    right: 0px;
    // top: 800px;
    width: 100%;
    margin-top: 0px;
  }
`;

export const Header = styled.header`
  padding: 20px 10px 10px;

  h1 {
    font-size: 1.6rem;
    font-weight: 600;
  };

	h2 {
		font-weight: 500;
	};

	// 479px
  @media (max-width: 29.9375rem) {
		h2 {
			font-size: 1.2rem;
			font-weight: 500;
		};
	}
`;

export const TabsView = styled.div`
  display: flex;
  width: 100%;
  height: 90%;
  // border: 2px solid blue;

  .tabs {
    width: 100%;

    .tab-list {
      .tab {
				font-size: 1.2rem;
        font-weight: 600;

        :focus {
          box-shadow: 0 0 0 0;
          border: 0 0;
        }
      }
    }

    .tab-panels {
      width: 100%;
      height: 93.5%;
      position: relative;
      // border: 2px solid orange;

      .tab-panel {
        width: 100%;
        padding: 0;
      }
    }
  }
`;

export const TabConta = styled(TabPanel)`
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  width: 100%;
  height: 100%;
`;

export const FormView = styled(Form)`
  display: flex;
	flex-direction: column;
  width: 100%;
  padding: 5px 0;
  margin-bottom: 60px;

  div.form-left {
    display: flex;
    flex-direction: column;
    width: 100%;

    div.input {
      display: flex;
      flex-direction: column;

      p {
        font-size: 1rem;
        font-weight: 500;
        margin: 15px 0 3px;

        span {
          font-size: 0.8rem;
          color: #455a64;
        }
      }

      span {
        font-size: 0.8rem;
        font-weight: 500;
        color: #455a64;
        text-align: end;
        width: 100%;
        padding: 5px 10px 0 0;
      }
    }
  }
  div.form-right {
    display: flex;
    flex-direction: column;
    width: 70%;
    padding: 10px;
		// border: 2px solid blue;

    p {
      font-size: 1rem;
      font-weight: 500;
    }

    span {
      font-size: 0.8rem;
      font-weight: 500;
      margin-bottom: 10px;
    }

    div.dados-imagem {
      display: flex;
      margin: 0 0 -10px;
      padding: 0 0 -10px;

      span {
        font-size: 0.8rem;
        font-weight: 400;
        margin: 0;
        padding: 0;
      }
      p {
        font-size: 0.8rem;
        font-weight: 600;
        margin: 0;
        padding: 0;
      }
    }
  }

	// 479px
  @media (max-width: 29.9375rem) {
		flex-direction: column-reverse;

		div.form-right {
			width: 100%;
			justify-content: center;
			align-items: center;
		}
	}
`;

export const Buttons = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  background-color: #fff;
  position: fixed;
  bottom: 0;
  right: 0;
  width: 700px;

  button {
    font-weight: 600;
    border-radius: 7px;
    padding: 10px 20px;
    margin: 5px 10px;
  }

  .button-cancel {
    background-color: transparent;
    color: var(--red-razio);
    border: 1px solid var(--red-razio);
  }
  .button-save {
    background-color: var(--azul-razio);
    color: #fff;
    border: 1px solid var(--azul-razio);

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }
`;

export const TabBoleto = styled(TabPanel)`
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  width: 100%;
  height: 100%;

  div.tab-content {
    display: flex;
    flex-direction: column;
    margin-bottom: 70px;
  }
`;

export const TabPix = styled(TabPanel)`
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  width: 100%;
  height: 100%;

  div.tab-content {
    display: flex;
    flex-direction: column;
    margin-bottom: 70px;
  }
`;

export const SelectedYesNo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 10px 10px 10px 10px;
  background-color: #eceff1;
  border-radius: 8px;
  width: 100%;
  margin-top: 10px;

  h1 {
    font-size: 1rem;
    font-weight: 500;
    margin-bottom: 0.050rem;
  }

  .radio-group {
		padding-left: 10px;
		display: flex;
		flex-direction: row;
		
    .radio {
			:last-child {
        margin-left: 2rem;
      }

      .radio-label {
        display: flex;
        align-items: center;

        :last-child {
          margin-top: 5px;
        }

        input[type='radio'] {
          margin-right: 5px;
          appearance: none;
          font: inherit;
          color: var(--azul-razio);
          width: 18px;
          height: 18px;
          border: 2px solid var(--gray-border-lw);
          border-radius: 50%;

          :checked {
            border: 5px solid var(--azul-razio);
          }
        }

        label {
          font-size: 17px;
        }
      }
    }
  };

	// 479px
  @media (max-width: 29.9375rem) {
		padding: 20px 20px 30px;

		.radio-group {
			.radio {
				.radio-label {
					input[type='radio'] {
						width: 21px;
						height: 18px;
						border: 5px solid var(--gray-border-lw);

						:checked {
							border: 5px solid var(--azul-razio);
						}
					}

					label {
						font-size: 1.1rem;
						font-weight: 500;
					}
				}
			}
		}
	}
`;
